var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageWrapDefault',{attrs:{"errorMessage":_vm.errorMessage,"successMessage":_vm.successMessage,"showSearch":true,"topActionButtonSecondary":{
    text: 'Actions',
    key: 'actions',
    subItems: [
      _vm.viewingRecycleBin
        ? { title: 'Back to Roof Structures', command: 'roofStructures' }
        : {
            title: 'Recycle Bin',
            command: 'roofStructures-recycle-bin'
          },
      { title: 'All Activities', command: 'roofStructures-activities' }
    ]
  },"topActionButtonPrimary":_vm.viewingRecycleBin
      ? {}
      : {
          text: 'Create Roof Structure',
          key: 'createRoofStructure'
        }},on:{"toolbarSelectItem":_vm.onToolbarItemClick,"errorMessageClosed":function($event){_vm.errorMessage = ''}}},[_c('ListView',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading || _vm.loadingText),expression:"loading || loadingText"}],attrs:{"hideAllFilters":false,"tableRowActions":_vm.tableRowActions,"element-loading-text":_vm.loadingText,"data":_vm.roofStructures,"tableActions":_vm.tableActions,"addAdvancedFilter":false,"tableColumns":_vm.tableColumns,"hideToggleIcons":true,"totalRecords":_vm.getTotalRecords,"paginationLinks":_vm.getRoofStructuresLinks,"showSelectable":true,"bulkMenuActions":_vm.bulkMenuActions},on:{"fetch-query":_vm.fetchPageData,"tableRowClicked":_vm.viewCallback,"table-row-action":_vm.handleResponseAction,"bulk-action-event":_vm.bulkActionHandler,"selection-change":function($event){_vm.selectedDocuments = $event}}},[_c('NoResultsFound',{attrs:{"slot":"notFound","message":_vm.viewingRecycleBin
          ? 'Recycle Bin is empty.'
          : 'Roof structures not found.'},slot:"notFound"})],1),_c('ModalMessage',{attrs:{"name":"roofStructureDeleteModal","icon":['fal', 'exclamation-circle'],"iconClass":"text-red-600 text-6xl","title":"Roof Structure Deletion","description":"This will delete the roof structure. Continue?","showClose":true,"buttons":[
      {
        text: 'Okay',
        classList: ['bg-gray-100 text-gray-600 border-gray-300'],
        click: () => _vm.deleteOneRoofStructure()
      },
      {
        text: 'Cancel',
        classList: ['bg-red-700'],
        click: () => _vm.$modal.hide('roofStructureDeleteModal')
      }
    ]}}),_c('ModalMessage',{attrs:{"name":"roofStructuresBulkDeleteModal","icon":['fal', 'exclamation-circle'],"iconClass":"text-red-600 text-6xl","title":"Roof Structure(s) Deletion","description":"This will delete the selected roof structures. Continue?","showClose":true,"buttons":[
      {
        text: `Okay`,
        classList: ['bg-gray-100 text-gray-600 border-gray-300'],
        click: () => _vm.doDeleteBulkRoofStructures()
      },
      {
        text: `Cancel`,
        classList: ['bg-red-700'],
        click: () => _vm.$modal.hide('roofStructuresBulkDeleteModal')
      }
    ]}}),_c('ModalMessage',{attrs:{"name":"roofStructuresBulkRestoreModal","icon":['fal', 'exclamation-circle'],"iconClass":"text-blue-600 text-6xl","title":"Roof Structure(s) Restoration","description":"This will restore the selected roof structures. Continue?","showClose":true,"buttons":[
      {
        text: `Okay`,
        classList: ['bg-gray-100 text-gray-600 border-gray-300'],
        click: () => _vm.doRestoreBulkRoofStructures()
      },
      {
        text: `Cancel`,
        classList: ['bg-red-700'],
        click: () => _vm.$modal.hide('roofStructuresBulkRestoreModal')
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }